import React from 'react';
import VegaIcon from './vegaIcons';
import { HERO_COPY_VARIANTS } from './vegaData';

export default function VegaHero({ copyIndex = 0 }) {
  const c = HERO_COPY_VARIANTS[copyIndex] || HERO_COPY_VARIANTS[0];

  return (
    <section className="relative vd-section-y px-6 lg:px-10">
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <div className="vd-eyebrow vd-fadeup" style={{ marginBottom: '1.5rem' }}>
          {c.eyebrow}
        </div>

        <h1
          className="vd-font-display vd-ink vd-fadeup"
          style={{
            fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
            lineHeight: 1.05,
            textWrap: 'pretty',
          }}
        >
          {c.title_pre}{' '}
          <span style={{ display: 'inline' }}>
            <span className="vd-underline-accent vd-accent-text" style={{ fontStyle: 'italic' }}>
              {c.title_verb}
            </span>
          </span>
          {c.title_post}
          <span style={{ display: 'inline-flex', verticalAlign: 'middle', marginLeft: '0.75rem' }}>
            <a
              href="https://calendly.com/raj-archetypical"
              target="_blank"
              rel="noreferrer"
              className="vd-btn-primary"
              style={{ fontFamily: '"Inter Tight", system-ui, sans-serif', fontStyle: 'normal' }}
            >
              Get early access <VegaIcon name="arrow" className="w-4 h-4" />
            </a>
          </span>
        </h1>

        <p
          className="vd-ink-soft vd-fadeup"
          style={{
            marginTop: '2rem',
            maxWidth: '42rem',
            fontSize: '1.125rem',
            lineHeight: 1.7,
            textWrap: 'pretty',
          }}
        >
          {c.sub}
        </p>
      </div>
    </section>
  );
}
